import React from 'react';

import { DashboardFooterLayoutComponent } from 'design/dashboardFooterLayout';
import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { InlineLayout } from 'design/inlineLayout';
import { LinkControlComponent } from 'design/linkControl';
import { INFO_SITE_URL, EMPLOYEE_INFO_SITE_URL } from 'utils/constants';
import { routes } from 'utils/routes';

export const PartnerDashboardFooter = () => {
  const {
    shared: sharedDictionary,
    partnerDashboard: { footer: ownDictionary },
  } = useIntlDictionary();

  const copyrightNode = React.useMemo(() => {
    const copyrightText = ownDictionary.copyrightText();

    return <TextComponent size="s">{copyrightText}</TextComponent>;
  }, [ownDictionary]);

  const linksNode = React.useMemo(
    () => (
      <InlineLayout gap="18px">
        <LinkControlComponent newTab to={INFO_SITE_URL}>
          <TextComponent size="s">
            {sharedDictionary.supportLinkText}
          </TextComponent>
        </LinkControlComponent>
        <LinkControlComponent newTab to={EMPLOYEE_INFO_SITE_URL}>
          <TextComponent size="s">
            {sharedDictionary.employeeLinkText}
          </TextComponent>
        </LinkControlComponent>
        <LinkControlComponent newTab to={routes.registrationDemo()}>
          <TextComponent size="s">
            {sharedDictionary.registerDemoLinkText}
          </TextComponent>
        </LinkControlComponent>
      </InlineLayout>
    ),
    [
      sharedDictionary.employeeLinkText,
      sharedDictionary.registerDemoLinkText,
      sharedDictionary.supportLinkText,
    ]
  );

  return (
    <DashboardFooterLayoutComponent
      copyright={copyrightNode}
      links={linksNode}
    />
  );
};
